/* THE COOL PEOPLE — page interactions. Vanilla, no library.
   Transform/opacity only; all motion no-ops under prefers-reduced-motion.

   APPROACH: this theme is a custom build, not Dawn, so its card / pill class
   names are unknown. Rather than guess selectors in CSS, we find elements
   STRUCTURALLY (a link to /products/ containing an image) or by TEXT
   ("Choose options", "All Products"), tag them with our own cp-* classes, and
   let the stylesheet target those. */
(function () {
  'use strict';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. scroll reveal + hero entrance ---- */
  function observe() {
    var els = document.querySelectorAll('.cp-reveal:not([data-cp-seen]),.cp-hero:not([data-cp-seen])');
    if (!els.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); el.setAttribute('data-cp-seen', '1'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        setTimeout(function () { el.classList.add('is-in'); },
                   parseFloat(el.getAttribute('data-cp-delay') || '0'));
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { el.setAttribute('data-cp-seen', '1'); io.observe(el); });
  }
  function hero() {
    var h = document.querySelector('.cp-hero');
    if (h) requestAnimationFrame(function () { h.classList.add('is-in'); });
  }

  var BUY_TEXT = /^(choose options?|add to cart|select options?|quick add|quick view|buy now|shop now|add)$/i;

  /* ---- 2. remove the buy control ----
     Scanned GLOBALLY rather than within a card: our card element resolves to a
     wrapper that does not always contain the button. On a collection page any
     "Choose options" belongs to a card, so a page-wide text match is safe and
     immune to unknown class names. Drawers/header/footer are excluded. */
  function hideBuyControls() {
    document.querySelectorAll('a, button, input[type="submit"], [role="button"]').forEach(function (el) {
      if (el.hasAttribute('data-cp-hidden')) return;
      var label = (el.textContent || el.value || '').trim();
      if (!BUY_TEXT.test(label)) return;
      if (el.closest('dialog, .drawer, .menu-drawer, .facets__drawer, cart-drawer, .cp-hero, header, footer')) return;
      var host = el.closest('form') || el;
      host.setAttribute('data-cp-hidden', '1');
      host.style.setProperty('display', 'none', 'important');
    });
  }

  /* ---- 3. cards + uniform tile ----
     Climb from the product image link until we reach an ancestor that also
     holds the price text, so .cp-card wraps the WHOLE card rather than just the
     media. Capped at 6 levels so we can never select the entire grid. */
  function cardRoot(a) {
    var known = a.closest('li, .card-wrapper, .card, .grid__item, .product-card');
    if (known) return known;
    var n = a, i = 0;
    while (n && n.parentElement && i < 6) {
      n = n.parentElement;
      if (n.querySelector('img') && /[₹$]|\d{3}/.test(n.textContent || '')) return n;
      i++;
    }
    return a.parentElement;
  }
  function cards() {
    document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var img = a.querySelector('img');
      if (!img) return;
      var wrap = img.parentElement;
      if (wrap && !wrap.classList.contains('cp-tile-fix')) wrap.classList.add('cp-tile-fix');
      var root = cardRoot(a);
      if (root && !root.classList.contains('cp-card')) root.classList.add('cp-card');
    });
  }

  /* ---- 4. prices ----
     Real markup (snippets/price.liquid):
       .price__regular > .price-item.price-item--regular      full price
       .price__sale    > .price-item.price-item--sale         live price
       .price__sale    > span > s.price-item.price-item--regular   compare-at
     The compare-at <s> carries the SAME class as the full price, which is why
     styling that class struck through every full-price item. And the theme
     colours .price-item--sale with equal specificity + !important, so a
     stylesheet could not reliably win — hence inline styles here. */
  function prices() {
    document.querySelectorAll('.price__sale .price-item--sale').forEach(function (el) {
      el.style.setProperty('color', '#ffffff', 'important');
      el.style.setProperty('font-weight', '700', 'important');
      el.style.setProperty('opacity', '1', 'important');
    });
    document.querySelectorAll('.price__regular .price-item--regular').forEach(function (el) {
      el.style.setProperty('color', '#ffffff', 'important');
      el.style.setProperty('font-weight', '600', 'important');
    });
    document.querySelectorAll('.price s, .price__sale s, .price__regular s').forEach(function (el) {
      el.style.setProperty('color', '#7d7d7d', 'important');
      el.style.setProperty('font-weight', '400', 'important');
      el.style.setProperty('text-decoration', 'line-through', 'important');
    });
  }

  /* ---- 5. category pills row ---- */
  function pills() {
    if (document.querySelector('.cp-pills')) return;
    var all = document.querySelectorAll('a');
    for (var i = 0; i < all.length; i++) {
      if (/^all products$/i.test((all[i].textContent || '').trim())) {
        if (all[i].parentElement) all[i].parentElement.classList.add('cp-pills');
        return;
      }
    }
  }

  /* ---- 6. front/back image swap ----
     Delegated, so cards injected by filtering or pagination need no re-binding.
     The alternate image is fetched from the product JSON on FIRST hover only
     and cached, so the grid never pays for images nobody looks at. */
  var cache = {};
  function sized(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : u; }
  function swap(card) {
    if (card.hasAttribute('data-cp-alt')) return;
    card.setAttribute('data-cp-alt', 'pending');
    var link = card.querySelector('a[href*="/products/"]');
    var media = card.querySelector('.cp-tile-fix');
    if (!link || !media) { card.setAttribute('data-cp-alt', 'none'); return; }
    var path = link.getAttribute('href').split('?')[0];
    var done = function (src) {
      if (!src) { card.setAttribute('data-cp-alt', 'none'); return; }
      var img = new Image();
      img.className = 'cp-alt'; img.loading = 'lazy'; img.decoding = 'async'; img.alt = '';
      img.src = sized(src, 700);
      media.appendChild(img);
      card.setAttribute('data-cp-alt', 'ready');
    };
    if (cache[path] !== undefined) return done(cache[path]);
    fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { var s = p && p.images && p.images.length > 1 ? p.images[1] : null; cache[path] = s; done(s); })
      .catch(function () { cache[path] = null; card.setAttribute('data-cp-alt', 'none'); });
  }
  document.addEventListener('pointerover', function (e) {
    if (!e.target || !e.target.closest) return;
    var c = e.target.closest('.cp-card');
    if (c) swap(c);
  }, { passive: true });

  /* ---- 7. marquee speed derived from content width ---- */
  function marquees() {
    document.querySelectorAll('.cp-marquee:not([data-cp-init])').forEach(function (m) {
      m.setAttribute('data-cp-init', '1');
      var track = m.querySelector('.cp-marquee__track');
      if (!track) return;
      var px = track.scrollWidth / 2 || 1200;
      var pps = parseFloat(m.getAttribute('data-speed') || '70');
      m.style.setProperty('--cp-speed', Math.max(12, px / pps) + 's');
    });
  }

  function pass() { cards(); hideBuyControls(); prices(); pills(); observe(); }
  function init() { hero(); marquees(); pass(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);

  /* the grid re-renders on filter / sort / paginate — debounced so our own
     class writes cannot drive the observer in a loop */
  var t = null;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(pass, 150); })
    .observe(document.body, { childList: true, subtree: true });
})();
